import React from 'react'
import MaterialSymbol from '../material-symbol'

const LocalPhone = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="local_phone" {...props} />
))

LocalPhone.displayName = 'LocalPhone'

export default LocalPhone
